// extracted by mini-css-extract-plugin
module.exports = {"container":"SpDropDownList_container__3XcsL","icon":"SpDropDownList_icon__3Azln","text":"SpDropDownList_text__i1htn"};